import { getDataEvent } from "./helpers";
import { AutodataTrackingTypes } from "./ts/types";

export default (
  domElements: HTMLElement[],
  autoData: AutoData
): DisposableApp => {
  const disposableClickHandlers: DisposableEventListener[] = Array.from(
    domElements
  ).map((domElement: HTMLElement) => {
    const listItemDOMNode = domElement.closest(
      '.contacts__list_item[data-event-category="faq|contact"]'
    );

    const clickHandler = () => {
      autoData.sendEvent(
        getDataEvent(
          listItemDOMNode as HTMLElement,
          AutodataTrackingTypes.onClick
        )
      );
    };

    domElement.addEventListener("click", clickHandler);

    return [domElement, clickHandler];
  });

  return function disposableCallback() {
    disposableClickHandlers.forEach(([domElement, clickHandler]) => {
      domElement.removeEventListener("click", clickHandler);
    });
  };
};
